module.exports = __webpack_public_path__ + "img/logo.a81dc90c.svg";